module.exports = __webpack_public_path__ + "img/close.3f6b9236.svg";